import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from 'react-toastify';
import { staticPermissionData } from "helpers/GeneralHelper";
import { useNavigate } from "react-router-dom";
import { loginData } from "model/LoginModel";
import { fetchJobCategoryTableAndFilterSchema } from "model/CategoryModel";
import { fetchJobRequiredTableAndFilterSchema } from "model/JobRequiredModel";
import { fetchQuestionTypeTableAndFilterSchema } from "model/QuestionTypeModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";


const QuestionTypeContext = createContext();

export const QuestionTypeProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [userData, setUserData] = useState();
    const navigate = useNavigate();
    const [permissionData, setPermissionData] = useState();
    const [questionTypeContextData, setQuestionTypeContextData] = useState();


    // const fetchQuestionTypeContextData = async () => {
    //     const columns = [
    //         { title: "ID", field: "jobCategoryid" },
    //         { title: "Name", field: "jobCategoryName" },
    //         { title: "Video", field: "videoLink" },
    //         { title: "Incentive", field: "incentiveType" },
    //         { title: "Quota is On", field: "quotaIsOn" },
    //         { title: "Status", field: "jobCategoryStatus" },
    //     ];

    //     setLoading(true);
    //     try {
    //         let response = await fetchJobCategoryTableAndFilterSchema();
    //         if (response?.success) {
    //             setLoading(false);
    //             console.log('...response', response)
    //             const columns = response?.data
    //             const valueReModified = columns?.map(col => ({
    //                 Header: col?.title,
    //                 accessor: col?.field,
    //             }));
    
    //             setQuestionTypeContextData(valueReModified);
    //           }
    //           else {
    //             setLoading(false);
    //             toast?.error(response?.Message)
    //           }
            
    //     } catch (err) {
    //         toast.error(err.message);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

     // 🔹 Fetch home page data once
  const fetchQuestionTypeContextData = async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema("metadata:questionType", () =>
        fetchQuestionTypeTableAndFilterSchema([])
      );
      if (response?.success) {
        setQuestionTypeContextData(response?.data);
      }
    } catch (err) {
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };



    // 🔹 Fetch home page data once

    useEffect(() => {
        const fetchAll = async () => {
            await Promise.all([]);
        };
        fetchAll();
    }, []);

    return (
        <QuestionTypeContext.Provider value={{ fetchQuestionTypeContextData, questionTypeContextData, permissionData, loading, error }}>
            {children}
        </QuestionTypeContext.Provider>
    );
};

export const useQuestionTypeContext = () => useContext(QuestionTypeContext);
